<button
  mat-stroked-button
  class="google-button"
  [disabled]="disabled || isLoading">
  {{ text }}
</button>
